import { render, staticRenderFns } from "./serviceModules.vue?vue&type=template&id=21cdcffe&scoped=true&"
import script from "./serviceModules.vue?vue&type=script&lang=js&"
export * from "./serviceModules.vue?vue&type=script&lang=js&"
import style0 from "./serviceModules.vue?vue&type=style&index=0&id=21cdcffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cdcffe",
  null
  
)

export default component.exports